export default __webpack_public_path__ + "static/media/linkedin.0a86bd6e.png";